import { Component, ViewEncapsulation } from '@angular/core';
import { Location } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

import { pageTransitions } from '../../animations/page-transitions';
import { UserService } from '../../services/user.service';
import { User } from '../../models/user';
import { BUILD_NUMBER } from '../../../config';
import { BackButtonComponent } from '../back-button/back-button.component';

import { LegalPrivacyPolicyComponent } from './privacy-policy/legal-privacy-policy.component';
import { LegalDocumentComponent } from './legal-documents/legal-documents.component';

@Component({
	selector: 'copo-legal-data',
	templateUrl: './legal-data.component.html',
	styleUrl: './legal-data.component.css',
	animations: pageTransitions,
	encapsulation: ViewEncapsulation.Emulated,
	imports: [BackButtonComponent, TranslateModule, LegalDocumentComponent, LegalPrivacyPolicyComponent]
})
export class LegalDataComponent {
	user: User;
	readonly buildNumber = BUILD_NUMBER;

	constructor(
		private readonly location: Location,
		private readonly userService: UserService
	) {
		this.user = this.userService.user;
	}

	getBack() {
		this.location.back();
	}
}
